import React from "react"
import propTypes from "prop-types"
import i18n from "i18n"
import { Box } from "@mui/material"
import { useAuthContext } from "context/auth/authContext"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import { NEW_STRUCTURE } from "context/types"
import useEntitlementGuard from "hooks/useEntitlementGuard"
import { IMPORT_BC3_LINK } from "constants/entitlements"
import AddPartidaActions from "./AddPartidaActions"

const EmptyChapterActions = ({ chapterId, onCreatePart, testId }) => {
  const { freeTrialExpired, openFreeTrialExpire } = useAuthContext()
  const { bc3Link, partBrowser } = useWrapperModals()
  const [checkEntitlement, entitlementDialog] = useEntitlementGuard()

  const guard = action => () => {
    if (freeTrialExpired) {
      openFreeTrialExpire()
      return
    }
    action()
  }

  const handleSearchPart = () => {
    partBrowser.setProperty({
      open: true,
      from: NEW_STRUCTURE,
      chapterId,
    })
  }

  const handleImportFromLink = () => {
    if (!checkEntitlement(IMPORT_BC3_LINK, i18n.t("importBC3Link.link"))) return
    bc3Link.setProperty({
      open: true,
      from: NEW_STRUCTURE,
      chapterId,
    })
  }

  return (
    <>
      <Box
        sx={{
          paddingTop: "18px",
          paddingBottom: "18px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <AddPartidaActions
          onSearch={guard(handleSearchPart)}
          onCreateManual={guard(onCreatePart)}
          onImport={guard(handleImportFromLink)}
          searchButtonProps={{ "data-element": "searchPartidaBtn" }}
          manualButtonProps={{ "data-testid": testId }}
          importButtonProps={{ "data-element": "importFromBC3LinkBtn" }}
        />
      </Box>
      {entitlementDialog}
    </>
  )
}

EmptyChapterActions.propTypes = {
  chapterId: propTypes.string,
  onCreatePart: propTypes.func.isRequired,
  testId: propTypes.string,
}

export default EmptyChapterActions
